import React from 'react';
import SidebarUnitDesktop
    from "components/sidebar/components/SidebarUnitDesktop";
import { MissionIcon} from "assets/icons";

const MissionLink = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"Mission"} 
            routeSidebar={"/missions"}
            icon={MissionIcon}
            text={"Missions"}
        />
    );
};

export default MissionLink;